__turbopack_context__.v({
  "root": "required-data-note-module-scss-module__7HocYW__root",
});
